import { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button, Row, Col } from "../../../ui/ot"
import { Toaster, toast } from 'sonner'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuthorisedValues } from '../../controllers/AuthorisedValuesController'
import AuthorisedValuesForm from './AuthorisedValuesForm'
import { useTranslation } from "react-i18next";

const AuthorisedValuesNewOrEdit = ({
    keyPrefix = 'library.backstage.authorized_values_management'

}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const thisJS = "NewOrEditAuthorisedValues"
    const { category, id } = useParams()
    const bIsPostMode = id === undefined
    const bIsPatchMode = !bIsPostMode
    const navigate = useNavigate()
    const formRef = useRef()
    const [modalLoading, setModalLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState(bIsPostMode ? "post" : (bIsPatchMode ? "patch" : "get"))

    const onFormFinish = (values) => {
        //console.log(thisJS, "onFormFinish", axiosMode, values)
        if (axiosMode === "get") { return; }
        if (bIsPostMode) {
            postAuthorisedValuesData([{ ...values }])
        } else if (bIsPatchMode) {
            patchAuthorisedValuesData([{ ...values }])
        }
    }

    const {
        AuthorisedValuesData,
        getAuthorisedValuesData,
        postAuthorisedValuesData,
        patchAuthorisedValuesData
    } = useAuthorisedValues({
        onBefore: ({ axiosMode, values }) => {
            console.log(thisJS, "AuthorisedValuesData", axiosMode, "onBefore", values)
            const bIsGet = axiosMode === "get"
            if (!bIsGet) { setModalLoading(true) }
        },
        onFinish: ({ axiosMode, status, values }) => {
            console.log(thisJS, "AuthorisedValuesData", axiosMode, "onFinish", status, values)
            const bIsPost = axiosMode === "post"
            const bIsPatch = axiosMode === "patch"
            if (bIsPost || bIsPatch) {
                const cMode = bIsPost ? "新增" : "修改"
                if (status === "success") {
                    toast.success(cMode + "成功");
                } else {
                    toast.error(cMode + "失敗");
                }
                setModalLoading(false)
            }
        }
    })

    useEffect(() => {
        if (bIsPostMode) {
            formRef.current.setValues({
				category: category, id: 0, branches: []
			})
        }
        if (bIsPatchMode) {
            getAuthorisedValuesData({
                id: id
            })
                .then((response) => {
                    let datas = response?.data
                    let firstData = datas?.find((ele) => true)
                    let defaultValue = firstData // {}
                    defaultValue.lib = defaultValue.description; delete defaultValue.description
                    defaultValue.lib_opac = defaultValue.description_opac; delete defaultValue.description_opac

                    let branches = defaultValue["branches"].map((val) => {
                        return {
                            label: val?.branchname,
                            value: val?.branchcode,
                        }
                    })
                    defaultValue['branches'] = branches                    
                    //console.log(thisJS, "ItemData", axiosMode, "useEffect", defaultValue)
                    formRef.current.setValues(defaultValue)
                })
        }
    }, [])
    return (
        <MainContainer>
            <Toaster />
            <WhiteBox>
                <Row className='mb-5'>
                    <Title>
                        {bIsPatchMode ? t('edit') : t('add')}{t('authorized_values')} 
                    </Title>
                </Row>
                <Row>
                    <Col span={24}>
                        <AuthorisedValuesForm
                            ref={formRef}
                            onFormFinish={onFormFinish}
                        />
                    </Col>
                    <Col span={24}>
                        <ButtonGroup classnName='mt-4'>
                            <Button onClick={() => formRef.current.onFormSubmit()}>{bIsPatchMode ? "儲存變更" : "新增項目"}</Button>
                            <Button variant="outline" onClick={() => navigate(`/library/backstage/authorized_values_management/${category}`)} >取消</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </WhiteBox>
        </MainContainer>    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const WhiteBox = styled.div`
background-color: #fff;
width: 100%;
padding: 1em;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

export default AuthorisedValuesNewOrEdit